export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-extra-wide.bdf8653f0a5f8359886f99cdb5f627a9.webp";